<template>
    <div class="atelier-content-container">
        <div
            v-for="(titleItem, titleIndex) in functionTitleList"
            :key="titleIndex"
            :class="`atelier-card-${titleIndex}`"
        >
            <div class="atelier-group-title">
                <CommonComponentsProductsTitleFunctionTitle :function-title="titleItem" :color-index="colorIndex" />
            </div>
            <div class="atelier-group-video">
                <CommonComponentsVideoPlayer
                    class="video"
                    :sources="[
                        {
                            src: titleItem.path,
                            type: 'video/mp4',
                        },
                    ]"
                    :poster="titleItem.poster"
                />
                <div v-if="titleItem.des" class="description">{{ $t(titleItem.des) }}</div>
            </div>
            <div v-if="titleItem.contents" class="product-features">
                <div v-for="(content, index) in titleItem.contents" :key="index">
                    <CommonComponentsTextWithCheckIcon>
                        <span class="text atelier-text-scroll">{{ $t(content.content) }}</span>
                        <template #subtext>
                            <div class="subtext atelier-text-scroll">{{ $t(content.subContent) }}</div>
                        </template>
                    </CommonComponentsTextWithCheckIcon>
                </div>
            </div>
        </div>
        <div class="atelier-content-bottom">
            <div class="video-text atelier-text-slide" v-html="$t('global_atelier_video_text')" />
            <CommonComponentsVideoPlayer
                class="video"
                :sources="[
                    {
                        src: path2,
                        type: 'video/mp4',
                    },
                ]"
                :poster="atelier2_Poster"
            />
            <CommonComponentsProductsDownload product="atelier" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import path1 from '@assets/Video/products/atelier/atelier1.mp4';
    import path2 from '@assets/Video/products/atelier/atelier2.mp4';
    import atelier1_Poster from '@assets/Video/products/atelier/atelier1.jpg';
    import atelier2_Poster from '@assets/Video/products/atelier/atelier2.jpg';
    import { ifCNLocale } from '~~/composables/useLocale.ts';
    const colorIndex = 4;
    const isCN = ifCNLocale();

    const functionTitleList: Array<FunctionTitle> = [
        {
            colorTitle: 'global_home_header_submenu_link_0_5',
            title: 'global_atelier_title_0',
            path: path1,
            poster: atelier1_Poster,
            contents: [
                {
                    content: 'global_atelier_content_0',
                    subContent: 'global_atelier_content_0_subtext',
                },
                {
                    content: 'global_atelier_content_1',
                    subContent: 'global_atelier_content_1_subtext',
                },
                {
                    content: 'global_atelier_content_2',
                    subContent: 'global_atelier_content_2_subtext',
                },
            ],
            des: 'global_atelier_video_des_0',
        },
    ];
</script>

<style lang="less" scoped>
    .atelier-content-container {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        width: .convert(1200px) [ @vw];
        margin: 0 auto;

        .atelier-group-title {
            margin: .convert(100px) [ @vw] 0 .convert(40px) [ @vw] 0;
            @media (max-width: @screen-mobile-width) {
                margin-bottom: .convert(15px) [ @vw-mobile];
            }
        }
        .atelier-group-video {
            display: flex;
            flex-direction: column;
            video {
                margin: 0 auto;
                width: 100%;
            }
            .description {
                margin-top: 8px;
                font-size: .convert(14px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    font-size: .convert(12px) [ @vw-mobile];
                }
            }
        }

        .product-features {
            display: flex;
            flex-direction: column;
            gap: .convert(24px) [ @vw];
            margin-top: 40px;

            :deep(.svg-check-icon) {
                height: .convert(33px) [ @vw];
                width: .convert(16px) [ @vw];
            }
            .text {
                color: #fff;
                font-size: .convert(28px) [ @vw];
            }
            .subtext {
                font-size: .convert(16px) [ @vw];
                opacity: 0.6;
            }

            @media (max-width: @screen-mobile-width) {
                gap: .convert(15px) [ @vw-mobile];
                margin-top: 20px;

                :deep(.svg-check-icon) {
                    height: .convert(16px) [ @vw-mobile];
                    width: .convert(8px) [ @vw-mobile];
                }
                .text {
                    color: #fff;
                    font-size: .convert(14px) [ @vw-mobile];
                }
                .subtext {
                    font-size: .convert(12px) [ @vw-mobile];
                    opacity: 0.6;
                    margin-top: 10px;
                }
            }
        }

        .atelier-content-bottom {
            margin-top: .convert(100px) [ @vw];

            .video-text {
                font-family: 'HarmonyOS Sans SC';
                font-size: .convert(28px) [ @vw];
                line-height: 160%; /* 44.8px */
                width: 90%;

                @media (max-width: @screen-mobile-width) {
                    font-size: .convert(14px) [ @vw-mobile];
                    line-height: 140%; /* 19.6px */
                    width: 100%;
                }
            }
            .video {
                width: 100%;
                margin-top: 20px;
            }
        }
    }
</style>
